<template>
  <div>
    <q-dialog :visible.sync="dialogVisible" title="拍摄类型" width="1000px" :innerHeight="450" @cancel="updateVal" :showFooter="false" @confirm="confirm" @close="updateVal">
      <div style="text-align: left; margin-bottom: 10px">
        <el-button
          v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$shootingTypeEditing'"
          :type="editStatus ? 'warning' : 'primary'"
          size="small"
          @click="edit"
          style="margin: 10px 0"
          >{{ editStatus ? "保存" : "编辑" }}</el-button
        >
        <el-button :type="'primary'" size="small" style="margin: 10px 0" @click="cancel" v-if="editStatus">取消</el-button>
      </div>
      <el-table :data="tableData" border height="360px" :span-method="objectSpanMethod" v-loading="loading">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          show-overflow-tooltip
          v-for="(item,index) in columnData"
          :key="item.prop"
          :align="item.children ? 'center' : item.align"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row[item.prop]" @blur="numInput(scope,item)" @input="scope.row[item.prop]=scope.row[item.prop].replace(/^0+(\d)|[^\d]+/g,'')" v-if="index > 3 && editStatus"></el-input>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  model: {
    prop: "visible",
    event: "input",
  },
  props: ["visible", "spuId", "skuList"],
  data() {
    return {
      dialogVisible: false,
      editStatus: false,
      loading: false,
      tableData: [],
      columnData: [],
      spanArr: [],
      spanIndex: 0
    };
  },
  computed: {},
  mounted() {
    this.dialogVisible = this.visible;
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit("input", false);
      }, 200);
      this.$emit("close", null);
    },
    confirm() {
      this.submit();
    },
    // 业务
    init() {
      this.loading = true;
      let data = {
        spuId: this.spuId,
      };
      this.$q.newProduct
        .shootingTypeSearch({ data })
        .then((res) => {
          if (res.code == 200) {
            this.columnData = []
            res.data.titleList.forEach((v) => {
              this.columnData.push({
                label: v.titleName,
                prop: v.propertyName,
                width: v.displayWidth,
                sortable: v.sortable == "1" ? "custom" : false,
                span: false,
                fixed: v.fixed == 1 ? "left" : false,
              });
            });
            this.tableData = res.data.records;
            this.computeSpanData(this.tableData)
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    numInput(scope, item) {
      this.tableData.forEach((v) => {
        if (scope.row.productCode === v.productCode) {
          v[item.prop] = scope.row[item.prop];
        }
      });
    },
    submit() {
      let data = this.tableData.filter((v) => v.temp)[0];
      data["skuCode"] = data.task;
      data["schedule"] = this.finalSkuList.find((v) => v.skuCode === data.skuCode).taskName;
      this.$q.newProduct
        .addProductRemark({
          data: {
            spuId: this.spuId,
            ...data,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.message);
          }
        })
        .finally((_) => {
          this.updateVal();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    edit() {
      this.editStatus = !this.editStatus;
      if(!this.editStatus) {
        let data = {
          spuId: this.spuId,
          configList: this.tableData
        }
        this.$q.newProduct.shootingTypeUpdate({ data: data })
        .then(res=>{
          if (res.code == 200) {
            this.$message.success('编辑成功');
            this.$emit('success')
            // this.init()
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err)=>{
          // this.init()
        })
      }
    },
    cancel() {
      this.editStatus = false
      // this.init()
    },
     // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1)
        this.spanIndex = 0
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].productCode === data[index - 1].productCode) {
          this.spanArr[this.spanIndex] += 1
          this.spanArr.push(0)
        } else {
          this.spanArr.push(1)
          this.spanIndex = index
        }
      }
    },
    objectSpanMethod({rowIndex, columnIndex}) {
      if (columnIndex > 1) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
// >>> .el-table tr:last-child .cell{
//   white-space: pre-line !important
// }
</style>
